(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ukena-custom-pieces"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const params = new URLSearchParams(window.location.search);
    const reference = params.get('work');
    const intent = params.get('intent');
    const allowedIntents = new Set(['connected-work', 'existing-work']);
    const intendedInterest = intent === 'fit-guide' ? 'Fit and measurements' : (allowedIntents.has(intent) ? 'Existing work or connected pair' : '');

    document.querySelectorAll('.ukena-custom-pieces__form').forEach(form => {
      const referenceInput = form.querySelector('[data-work-reference]');
      const interestSelect = form.querySelector('[data-enquiry-interest]');

      if (reference && referenceInput && !referenceInput.value) {
        referenceInput.value = reference.slice(0, 500);
      }

      if (intendedInterest && interestSelect && !interestSelect.value) {
        interestSelect.value = intendedInterest;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ukena-fit-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fit-enquiry]').forEach(link => {
    const work = new URLSearchParams(window.location.search).get('work');
    if (work) {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('work', work.slice(0,500));
      link.href = url.toString();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
